import React, { ComponentProps } from "react";

export default function CalendarIcon(props: ComponentProps<"svg">) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <path
        d="M14.1665 3.95866C13.8248 3.95866 13.5415 3.67533 13.5415 3.33366V1.66699C13.5415 1.32533 13.8248 1.04199 14.1665 1.04199C14.5082 1.04199 14.7915 1.32533 14.7915 1.66699V3.33366C14.7915 3.67533 14.5082 3.95866 14.1665 3.95866Z"
        fill="#D9D9D9"
      />
      <path
        d="M5.8335 3.95866C5.49183 3.95866 5.2085 3.67533 5.2085 3.33366V1.66699C5.2085 1.32533 5.49183 1.04199 5.8335 1.04199C6.17516 1.04199 6.4585 1.32533 6.4585 1.66699V3.33366C6.4585 3.67533 6.17516 3.95866 5.8335 3.95866Z"
        fill="#D9D9D9"
      />
      <path
        d="M18.9582 6.87467V5.83301C18.9582 4.10801 17.5582 2.70801 15.8332 2.70801H4.1665C2.4415 2.70801 1.0415 4.10801 1.0415 5.83301V6.87467H18.9582Z"
        fill="#D9D9D9"
      />
      <path
        d="M1.0415 8.125V15.8333C1.0415 17.5583 2.4415 18.9583 4.1665 18.9583H15.8332C17.5582 18.9583 18.9582 17.5583 18.9582 15.8333V8.125H1.0415ZM5.83317 15.8333C5.37484 15.8333 4.99984 15.4583 4.99984 15C4.99984 14.5417 5.37484 14.1667 5.83317 14.1667C6.2915 14.1667 6.6665 14.5417 6.6665 15C6.6665 15.4583 6.2915 15.8333 5.83317 15.8333ZM5.83317 11.6667C5.37484 11.6667 4.99984 11.2917 4.99984 10.8333C4.99984 10.375 5.37484 10 5.83317 10C6.2915 10 6.6665 10.375 6.6665 10.8333C6.6665 11.2917 6.2915 11.6667 5.83317 11.6667ZM9.99984 15.8333C9.5415 15.8333 9.1665 15.4583 9.1665 15C9.1665 14.5417 9.5415 14.1667 9.99984 14.1667C10.4582 14.1667 10.8332 14.5417 10.8332 15C10.8332 15.4583 10.4582 15.8333 9.99984 15.8333ZM9.99984 11.6667C9.5415 11.6667 9.1665 11.2917 9.1665 10.8333C9.1665 10.375 9.5415 10 9.99984 10C10.4582 10 10.8332 10.375 10.8332 10.8333C10.8332 11.2917 10.4582 11.6667 9.99984 11.6667ZM14.1665 15.8333C13.7082 15.8333 13.3332 15.4583 13.3332 15C13.3332 14.5417 13.7082 14.1667 14.1665 14.1667C14.6248 14.1667 14.9998 14.5417 14.9998 15C14.9998 15.4583 14.6248 15.8333 14.1665 15.8333ZM14.1665 11.6667C13.7082 11.6667 13.3332 11.2917 13.3332 10.8333C13.3332 10.375 13.7082 10 14.1665 10C14.6248 10 14.9998 10.375 14.9998 10.8333C14.9998 11.2917 14.6248 11.6667 14.1665 11.6667Z"
        fill="#D9D9D9"
      />
    </svg>
  );
}
